import { render, staticRenderFns } from "./studentAnalysisReport.vue?vue&type=template&id=5c875f39&scoped=true"
import script from "./studentAnalysisReport.vue?vue&type=script&lang=js"
export * from "./studentAnalysisReport.vue?vue&type=script&lang=js"
import style0 from "./studentAnalysisReport.vue?vue&type=style&index=0&id=5c875f39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c875f39",
  null
  
)

export default component.exports